import {store, history} from './store'
import {socket} from './socket'

export default store
export {store, history, socket}



// WEBPACK FOOTER //
// ./src/store/index.js